import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment";

const Welcome = ({ dispatch_post_authin_code }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  useEffect(() => {}, []);

  const [code, set_code] = useState("");

  return (
    <div class="d-flex flex-column justify-content-center text-white vh-100">
      <div id="particle" className="particles-box" />
      <main role="main" className="main">
        <div className="container">
          <section className="login-section mx-auto text-center">
            <div className="row">
              <div className="col-4 mx-auto mb-5">
                <img
                  className="img-fluid wow tada"
                  src="images/brand-white.svg"
                  alt="SC WORLD EXCHANGE"
                />
              </div>
            </div>
            <h1 className="display-4 font-weight-bold">
              {t("登録完了")}
            </h1>
            <p className="lead">{t("アカウントが作成されました。")}</p>
            {}
            <a
              className="btn btn-outline-light mt-3"
              href="signin.html"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/signin`,
                });
                window.scroll(0, 0);
              }}
            >
              <i className="fas fa-sign-in-alt" /> {t("ログイン画面へ")}
            </a>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Welcome;
